import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";

import { FollowButton } from "scmp-app/components/follow-button";

interface FollowButtonProps {
  $isEnabled: boolean;
}

export const Container = styled.div`
  inline-size: initial;
  block-size: auto;
  margin-block: 0;
  margin-inline: 20px;
  padding-block: 40px;
  padding-inline: 15px;

  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;

  border: 1px dashed #a1a1a1;
  border-radius: 16px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 680px;
    margin: auto;
    padding-block: 48px;
    padding-inline: 27px;
  }
  ${theme.breakpoints.up("desktop")} {
    inline-size: 908px;
    padding-block: 48px;
    padding-inline: 83px;
  }
`;

export const Title = styled.div`
  color: #001246;
  font-weight: 300;
  font-size: 18px;
  font-family: ${fontRoboto};
  line-height: 21.6px;
  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const TitleHighlight = styled(Title)`
  inline-size: 200px;
  margin: auto;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontRobotoCondensed};
  line-height: 21.6px;
  text-transform: uppercase;
  ${theme.breakpoints.up("tablet")} {
    inline-size: auto;

    font-size: 24px;
    line-height: 28.8px;
  }
`;

export const TitleWrapper = styled.div``;

export const LoginReminder = styled.div`
  color: #000000;
  font-weight: 300;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 17px;
  text-align: center;
`;

export const LoginReminderWrapper = styled.div`
  margin-block-start: 20px;
`;

export const ItemsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;

  margin-block: 20px;
  margin-inline: 0;
  ${theme.breakpoints.up("tablet")} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px 22px;

    margin-block: 44px;
  }
`;

export const LoginLink = styled.span`
  color: #4585ff;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: underline;

  cursor: pointer;
`;

export const StyledFollowButton = styled(FollowButton, {
  ...transientOptions,
})<FollowButtonProps>`
  button {
    display: flex;
    justify-content: center;

    inline-size: 270px;
    block-size: 43.65px;

    color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 19px;
    text-transform: uppercase;

    border-radius: 3px;

    background: #001246;

    cursor: ${props => (props.$isEnabled ? "pointer" : "initial")};

    opacity: ${props => (props.$isEnabled ? 1 : 0.2)};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
